<div class="d-flex justify-content-center error-info-block">
  <span class="d-block"><span class="fa fa-info-circle text-muted font-38px text-center"
      ngbTooltip="Please check with admin if project & tools are configured or verify if there is no data present"
      placement="top" tooltipClass="org-chart-tooltip">
      <div class="error-info-message">{{message}}</div>
    </span></span>
</div>